import React from "react";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TEXT, ARCHIVE_LICENSE_WARNING_TITLE } from "archive/constants";
import { TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY } from "stores/indices/IndicesStore";
const ArchiveRetentionStrategySummary = ({
  config: { index_action, max_number_of_indices },
  rotationStrategyClass = void 0
}) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Index retention strategy:"), /* @__PURE__ */ React.createElement("dd", null, "Archive"), rotationStrategyClass !== TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Max number of indices:"), /* @__PURE__ */ React.createElement("dd", null, max_number_of_indices)), /* @__PURE__ */ React.createElement("dt", null, "Index action:"), /* @__PURE__ */ React.createElement("dd", null, index_action)), /* @__PURE__ */ React.createElement(
  LicenseCheck,
  {
    text: ARCHIVE_LICENSE_WARNING_TEXT,
    title: ARCHIVE_LICENSE_WARNING_TITLE,
    bsStyle: "danger",
    licenseSubject: LICENSE_SUBJECTS.archive
  }
));
export default ArchiveRetentionStrategySummary;
